import { Icon, Button } from '@sanlam-glacier/app-common/components';
import { useReportForm } from 'modules/reports/hooks/useReportFormContext';
import { useGetReportCurrentStep } from 'modules/reports/hooks/useGetReportCurrentStep';
import { useNavigate } from 'react-router-dom';
import { routes } from 'routes/route-paths';

interface NextStepButtonProps {
  alignEnd?: boolean;
}

const NextStepButton: React.FC<NextStepButtonProps> = ({ alignEnd = false }) => {
  const currentStep = useGetReportCurrentStep() ?? 1;
  const navigate = useNavigate();

  const { isStepValid } = useReportForm();
  const navigateToNextStep = () => {
    const basePath = `/${routes.reports}/${routes.reportsRoutes.new}/`;
    let nextStepPath;
    switch (currentStep) {
      case 1:
        nextStepPath = `${basePath}${routes.reportsRoutes.newReportRoutes.reportPeriod}/`;
        break;
      case 2:
        nextStepPath = `${basePath}${routes.reportsRoutes.newReportRoutes.review}/`;
        break;
      case 3:
        nextStepPath = `${basePath}${routes.reportsRoutes.newReportRoutes.review}/`;
        break;
      default:
        nextStepPath = `${basePath}${routes.reportsRoutes.newReportRoutes.selectClients}/`;
        break;
    }
    navigate(nextStepPath);
  };

  return (
    <Button
      className={`create-new-report-button ${alignEnd ? 'align-end' : ''}`}
      onClick={navigateToNextStep}
      size={Button.SIZE.SMALL}
      startIcon={<Icon icon='content_add' />}
      disabled={!isStepValid(currentStep)}
      style={{ marginLeft: 'auto' }}
    >
      Continue
    </Button>
  );
};

export default NextStepButton;
